import { getCurrentInstance, onMounted } from 'vue';

export default function useProgressBar() {
  const app = getCurrentInstance()
  const progressBar = app.appContext.config.globalProperties.$Progress
  return progressBar;
}